import React, { FC } from 'react';
import Box from '@mui/material/Box';
import { SxProps } from '@mui/material';

import StringUtils from '../../utils/stringUtils';

import './TwInitialsIndicator.scss';

// TODO: Manage sizes when needed (default md)
// type InitialsIndicatorSize = 'sm' | 'md';

interface InitialsIndicatorProps {
  text: string;
  displayRawText?: boolean;
  className?: string;
  sx?: SxProps;
  onInitialsClick?: (e: React.MouseEvent<HTMLElement>) => void;
  showBottomBagde?: boolean;
  badgeContent?: JSX.Element;
}

const InitialsIndicator: FC<InitialsIndicatorProps> = ({
  text,
  displayRawText,
  className,
  sx,
  onInitialsClick,
  showBottomBagde = false,
  badgeContent
}) => {
  return (
    <Box
      component="div"
      className={`initials-indicator ${className}`}
      sx={sx}
      onClick={onInitialsClick}
    >
      {displayRawText ? text : StringUtils.getInitials(text)}
      {showBottomBagde && <Box className="initials-indicator__bagde">{badgeContent}</Box>}
    </Box>
  );
};

export default InitialsIndicator;
